var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"_text-center"},[_vm._v("Последние отзывы")]),_c('div',{attrs:{"id":"last-comments"}})])}]

export { render, staticRenderFns }